<section class="send-notification-container" fxLayoutAlign="center center">
  <mat-card appearance="outlined" fxFlex="95%">
    @if (!confirmSent) {
      <div>
        <div fxLayout="column" fxLayoutAlign="center center">
          <div fxLayout="row" fxLayoutAlign="center center" fxFlexFill>
            <div></div>
            <h1>
              <span fxFill class="with-icon">
                <mat-icon>announcement</mat-icon
                  ><span class="notification-send-title"
                  >Send An Announcement</span
                  >
                </span>
              </h1>
              <!-- I don't think we need to open this is a new page at all. I'll leave it in case that changes. -->
              <!--                    <div>-->
              <!--                        <a [routerLink]="['./send-notification']" title="Open In New Window" *ngIf="!isMaximized">-->
              <!--                            <mat-icon aria-label="Open In New Window">open_in_new</mat-icon>-->
            <!--                        </a>-->
            <!--                        <a [routerLink]="['./send-notification']" title="Cancel" *ngIf="isMaximized">-->
            <!--                            <mat-icon aria-label="Cancel">close</mat-icon>-->
          <!--                        </a>-->
        <!--                    </div>-->
      </div>
      <div fxLayout="row" fxLayoutAlign="center">
        @if (isTeacher | async) {
          <div>
            Complete the form below to send a message to all
            students in the selected classes.
          </div>
        }
        @if (isDistributor | async) {
          <div>
            Complete the form below to send a message to students
            and teachers in the selected program.
          </div>
        }
      </div>
    </div>
    @if (loading) {
      <div
        fxLayoutAlign="center center"
        class="spinner-box"
        >
        <mat-spinner diameter="40"></mat-spinner>
      </div>
    }
    @if (!loading) {
      <div>
        <send-notification
          (create)="sendNotification($event)"
          [courses]="courses"
          [languages]="languages"
          [isMaximized]="isMaximized"
          (cancel)="onClickCancel()"
          >
        </send-notification>
      </div>
    }
  </div>
}
@if (confirmSent) {
  <div>
    <mat-action-row>
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        fxFill
        fxFlex="100"
        >
        <div>Message sent</div>
        <div>
          <button
            mat-raised-button
            class="button okButton"
            type="button"
            color="primary"
            (click)="okay()"
            >
            Ok
          </button>
        </div>
      </div>
    </mat-action-row>
  </div>
}
</mat-card>
</section>
